import { createSlice } from "@reduxjs/toolkit"
import { submitCorporateForm } from "./CorporateAction";


const corporateSlice = createSlice({
    name: 'corporate',
    initialState: { loading: true, error: false, corporateForm: '', isSubmit: false},
    reducers: {
        clearError: (state) => {
            state.error = false;
        },
        clearSubmit: (state) => {
            state.isSubmit = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitCorporateForm.pending, (state) => {
                state.loading = true;
            })
            .addCase(submitCorporateForm.fulfilled, (state, action) => {
                state.corporateForm = action?.payload?.message;
                state.isSubmit = true;
                state.loading = false;
                state.error = false;
            })
            .addCase(submitCorporateForm.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            });
    }
});


const corporateAction = corporateSlice.actions;

export {corporateAction, corporateSlice};

